module.exports = __webpack_public_path__ + "img/treasure_box_small.6d3d7466.png";